import React, { useState } from 'react';
import DialogOrganisatieAdd from '../../components/controls/dialogs/DialogOrganisatieAdd';
import OverzichtOrganisaties from '../../components/organisaties/OverzichtOrganisaties';
import { Paper, Tab, Tabs } from '@mui/material';

const PageOrganisaties: React.FC = () => {
  const [callbackKey, setCallbackKey] = useState(0);
  const [value, setValue] = useState(0);

  // Function to trigger a refresh by changing the key
  const fetchOrganisaties = () => {
    setCallbackKey((prevKey) => prevKey + 1); // Increment the key to force re-render
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  }

  return (
    <>
      <header className="app-header">
        <h1>Organisaties beheren</h1>
        <p className="header-sub-title center">
          In onderstaand overzichten worden alle organisaties getoond die toegevoegd zijn aan infraplannen.nl.<br/>
          Deze zijn verdeeld in gebieden met een bestuurlijkgebied en zonder gebied.<br/>
        </p>
      </header>

      <div className="content text-left">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="icon position tabs example"
        >
          <Tab iconPosition="start" label="Met gebied" />
          <Tab label="Zonder gebied" />
        </Tabs>
        <div hidden={value !== 0}>
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Organisaties met bestuurlijkgebied</h4>
              <p>Dit zijn organisaties met een bestuurlijkgebied. Vanuit dit overzicht kan een organisatie worden toegevoegd, gewijzigd of verwijderd.</p>
              <DialogOrganisatieAdd isZonderGebied={false} callback={fetchOrganisaties} />
              
              <OverzichtOrganisaties isZonderGebied={false} key={callbackKey} />
            </div>
            
          </Paper>
        </div>
        <div hidden={value !== 1}>
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Organisaties zonder gebied</h4>
              <p>Dit zijn organisaties zonder gebied. Vanuit dit overzicht kan een organisatie worden toegevoegd, gewijzigd of verwijderd.</p>
              <DialogOrganisatieAdd isZonderGebied={true} callback={fetchOrganisaties} />
              
              <OverzichtOrganisaties isZonderGebied={true} key={callbackKey} />
            </div>
          </Paper>
        </div>
      </div>
    </>
  );
};

export default PageOrganisaties;